import React, { useState } from "react";
import "./ContactForm.scss";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PlaceIcon from "@mui/icons-material/Place";
import { useTheme } from "@mui/material/styles";
import { colors } from "@mui/material";

const API_URL = process.env.REACT_APP_API_URL;

export default function ContactForm() {
    const theme = useTheme();

    const [formData, setFormData] = useState({ name: "", email: "", message: "" });
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [agreed, setAgreed] = useState(false);

    const handleChange = (e) =>
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        // ...same validation and fetch logic as you already have
    };

    return (
        <div className="contact-page">
            {/* Info Cards Section */}
            <div className="contact-info-cards">
                <div className="info-card">
                    <div className="info-icon">
                        <MailOutlineIcon
                            sx={{
                                width: 24,
                                height: 24,
                                color: theme.palette.about.light,
                            }}
                        />
                    </div>
                    <h3>Nasz adres Email</h3>
                    <p>biuro@carlobossi.com.pl</p>
                </div>

                <div className="info-card">
                    <div className="info-icon">
                        <LocalPhoneIcon
                            sx={{
                                width: 24,
                                height: 24,
                                color: theme.palette.about.light,
                                borderRadius: "50%",
                                p: 0.5,
                            }}
                        />
                    </div>
                    <h3>Numer kontaktowy</h3>
                    <p>Numer: +48 15 642 61 51</p>
                    <p>FAX: +48 15 841 22 49</p>
                </div>

                <div className="info-card">
                    <div className="info-icon">
                        <PlaceIcon
                            sx={{
                                width: 24,
                                height: 24,
                                color: theme.palette.about.light,
                            }}
                        />
                    </div>
                    <h3>Nasz adres</h3>
                    <p>37-400 Nisko ul. Zielona 35</p>
                    <p>37-400 Nisko ul. Nowa 32</p>
                    <p>Polska</p>
                </div>
            </div>

            {/* Contact Form Section */}
            <div className="contact-form-section">
                <div className="form-header">
                    <span className="contact-label">Skontaktuj się z nami</span>
                    <h2>Jak możemy pomóc?</h2>
                    <p className="form-description">
                        Masz pytania dotyczące naszych produktów lub potrzebujesz pomocy? Wypełnij formularz, a my skontaktujemy się z Tobą jak najszybciej.
                    </p>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-row">
                        <div className="form-group">
                            <label>
                                Twoje imię <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            />
                        </div>

                        <div className="form-group">
                            <label>
                                Twój adres Email <span className="required">*</span>
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                disabled={loading}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>
                            Twoja wiadomość <span className="required">*</span>
                        </label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            maxLength={300}
                            rows={6}
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="checkbox-group">
                        <input
                            type="checkbox"
                            id="agree"
                            checked={agreed}
                            onChange={(e) => setAgreed(e.target.checked)}
                            disabled={loading}
                        />
                        <label htmlFor="agree">
                            Zgadzam się na przetwarzanie moich danych osobowych.
                        </label>
                    </div>

                    <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? "Wysyłanie..." : "Wyślij wiadomość"}
                    </button>

                    {status?.success && <p className="success">{status.success}</p>}
                    {status?.error && <p className="error">{status.error}</p>}
                </form>
            </div>
        </div>
    );
}
